/**
 * @link https://mui.com/material-ui/react-text-field/
 */

import {Divider, MenuItem, TextField, Typography} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeTextfield() {
  return (
    <>
        <TextField label="Nachname, Vorname"
                   variant="outlined"
                   margin="normal"
                   helperText="Geben Sie hier Ihre persönlichen Daten ein."
                   fullWidth required />
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="outlined"
                   margin="normal"
                   helperText="Geben Sie hier Ihre persönlichen Daten ein."
                   fullWidth select>
            <MenuItem value="10">Ten</MenuItem>
            <MenuItem value="20">Twenty</MenuItem>
        </TextField>
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="outlined" margin="normal"
                   helperText="Bitte korrigieren Sie Ihre Eingabe"
                   fullWidth required
                   error />
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="outlined"
                   margin="normal"
                   helperText="Hier mit Multiline."
                   fullWidth
                   multiline
                   minRows={3} maxRows={5} />
        <p>&nbsp;</p>

        <Divider textAlign={"left"}><Typography variant={"h6"}>Text field (variant: filled)</Typography></Divider>

        <TextField label="Nachname, Vorname"
                   variant="filled"
                   margin="normal"
                   helperText="Geben Sie hier Ihre persönlichen Daten ein."
                   fullWidth required />
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="filled"
                   margin="normal"
                   helperText="Geben Sie hier Ihre persönlichen Daten ein."
                   fullWidth select>
            <MenuItem value="10">Ten</MenuItem>
            <MenuItem value="20">Twenty</MenuItem>
        </TextField>
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="filled"
                   margin="normal"
                   helperText="Bitte korrigieren Sie Ihre Eingabe"
                   fullWidth required
                   error />
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="filled"
                   margin="normal"
                   helperText="Hier mit Multiline."
                   fullWidth multiline
                   minRows={3} maxRows={5} />
        <p>&nbsp;</p>

        <Divider textAlign={"left"}><Typography variant={"h6"}>Text field (variant: standard)</Typography></Divider>

        <TextField label="Nachname, Vorname"
                   variant="standard"
                   margin="normal"
                   helperText="Geben Sie hier Ihre persönlichen Daten ein."
                   fullWidth required />
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="standard"
                   margin="normal"
                   helperText="Geben Sie hier Ihre persönlichen Daten ein."
                   fullWidth select>
            <MenuItem value="10">Ten</MenuItem>
            <MenuItem value="20">Twenty</MenuItem>
        </TextField>
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="standard"
                   margin="normal"
                   helperText="Bitte korrigieren Sie Ihre Eingabe"
                   fullWidth required
                   error />
        <br/>

        <TextField label="Nachname, Vorname"
                   variant="standard"
                   margin="normal"
                   helperText="Hier mit Multiline."
                   fullWidth multiline
                   minRows={3} maxRows={5} />
        <p>&nbsp;</p>
        
        <ShowCode 
          codeString={`<>
  {/* Outlined variant */}
  <TextField 
    label="Standard TextField" 
    variant="outlined" 
    margin="normal"
    helperText="Helper text provides additional guidance"
    fullWidth
  />
  
  {/* With error state */}
  <TextField 
    label="Error TextField" 
    variant="outlined" 
    margin="normal"
    helperText="Please correct your input"
    error
    fullWidth
  />
  
  {/* Select field */}
  <TextField 
    label="Select Option" 
    variant="outlined" 
    margin="normal"
    helperText="Choose from the dropdown"
    select
    fullWidth
  >
    <MenuItem value="10">Option One</MenuItem>
    <MenuItem value="20">Option Two</MenuItem>
    <MenuItem value="30">Option Three</MenuItem>
  </TextField>
  
  {/* Multiline text field */}
  <TextField 
    label="Multiline Input" 
    variant="outlined" 
    margin="normal"
    helperText="Enter multiple lines of text"
    multiline
    minRows={3}
    maxRows={5}
    fullWidth
  />
</>`} 
          scope={{ React, TextField, MenuItem }} 
        />
    </>
  )
}